import React, { useEffect, useState } from 'react'
import { Button, Card, Drawer, Form, Icon, Input, notification, Tooltip } from 'antd'
import { RowTable } from '../../../components/_utils/RowTable'
import { FormUtils as GetAllFormFields } from 'sz-react-utils-lite'
import { departmentObj, DocumentTypes, InputBox, oxfordUniversity } from '../../../components/_utils/appUtils'
import { loadFcmtApplicationDocuments, loadStudentDocuments, RequestLoaApproved } from '../actions/chooseStudent'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import lodash from 'lodash'
import UploadDocumentComponent from '../views/uploadDocumentComponent'

const initialState = {
  documentDrawerVisible: false,
  title: '',
  description: '',
  document: {},
  documentKey: moment(),
  page: ''
}
const DocumentDrawer = (props) => {
  let dispatch = useDispatch()
  let { visible, onClose, studentData } = props
  let { applications } = studentData
  let [state, setState] = useState(initialState)
  let [documents, setDocuments] = useState([])
  let [applicationDocument, setApplicationDocument] = useState([])
  let loginUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null

  useEffect(() => {
    events.loadDocuments()
    events.loadFcmtApplicationDocumentsFxn()
  }, [applications])

  const documentSubName = (name) => {
    let exp = name.split('.').pop()
    let nameVal = name.split('.')[0]
    if (nameVal.length > 10) {
      nameVal = `${nameVal.substring(0, 10)}[...].${exp}`
      return nameVal
    } else {
      return name
    }
  }
  const checkDepartment = () => { //check department not to be interview department
    return loginUser.approveRoyalArtsLoa || loginUser.approveFCMTLoa
  }
  const events = {
    showDrawer: (title, page) => {
      setState({ ...state, documentDrawerVisible: true, title, page })
    },
    hideDrawer: () => {
      setState({ ...state, documentDrawerVisible: false })
      events.loadDocuments()
      events.loadFcmtApplicationDocumentsFxn()
    },
    loadDocuments: async () => {
      let studentId = studentData._id
      let applicationId = applications._id
      let resp = await dispatch(loadStudentDocuments({ studentId, applicationId }))
      if (resp && resp.document && resp.document.length) {
        setDocuments(resp.document)
      }
    },
    loadFcmtApplicationDocumentsFxn: async () => {
      let studentId = studentData._id
      let applicationId = applications._id
      let resp = await dispatch(loadFcmtApplicationDocuments({ studentId, applicationId }))
      if (resp && resp._id) {
        setApplicationDocument(resp.applications)
      }
    }
  }


  return (
    <Drawer visible={visible}
            title={'Student Documents'}
            width={'40%'}
            closable={true}
            maskClosable={true}
            onClose={onClose}>
      <Card>
        {studentData && studentData.applications && studentData.applications.id ?
          <div className={'tableBox striped'}>
            <RowTable title={'Name (ID)'} value={<span>{studentData.name} ({studentData.studentId})</span>} />
            <RowTable title={'Application ID'} value={<span>{studentData.applications.id}</span>} />
            <RowTable title={'Application'} value={<span>{studentData.applications.courseName}</span>} />
            {checkDepartment() ?
              <RowTable title={'Attachments'} value={
                <a className='btn btn-default btn-xs' onClick={() => {
                  events.showDrawer('', 'document')
                }}>Upload Documents
                </a>
              }>
              </RowTable>
              : null}
          </div> : null}
        <div className={'mt10'}>
          {documents && documents.length ? <div>
            {documents.map((item, key) => {
              return (
                <div className='box' key={key} style={{ borderBottom: '1px solid black', paddingBottom: 10 }}>
                  <h6 style={{ marginTop: 20 }}>
                    {item.documentType}
                  </h6>
                  <Tooltip placement='topRight' title={item.title} key={key}>
                    <a href={item.url} download={item.url}>
                    <span style={{
                      backgroundColor: '#ddd',
                      borderRadius: 5,
                      padding: '5px 10px'
                    }}>  {documentSubName(item.name)}</span>
                    </a>
                  </Tooltip>
                </div>
              )
            })}
          </div> : null}
          {applicationDocument && applicationDocument.loaDocument && applicationDocument.loaDocument.length ? <div>
            {applicationDocument.loaDocument.map((item, key) => {
              return (
                <div className='box' key={key} style={{ borderBottom: '1px solid black', paddingBottom: 10 }}>
                  <h6 style={{ marginTop: 20 }}>
                    {item.status}
                  </h6>
                  <Tooltip placement='topRight' title={item.title} key={key}>
                    <a href={item.url} download={item.url}>
                    <span style={{
                      backgroundColor: '#ddd',
                      borderRadius: 5,
                      padding: 5
                    }}>  {documentSubName(item.name)}</span>
                    </a>
                  </Tooltip>
                </div>
              )
            })}
          </div> : null}
          {applicationDocument && applicationDocument.signedVisaDraft && applicationDocument.signedVisaDraft.path ?
            <div className='box' style={{ borderBottom: '1px solid black', paddingBottom: 10 }}>
              <h6 style={{ marginTop: 20 }}>
                Signed Visa Draft
              </h6>
              <Tooltip placement='topRight' title={' Signed Visa Draft'}>
                <a href={applicationDocument.signedVisaDraft.path} download={applicationDocument.signedVisaDraft.path}>
                    <span style={{
                      backgroundColor: '#ddd',
                      borderRadius: 5,
                      padding: 5
                    }}>  {documentSubName(applicationDocument.signedVisaDraft.fileName)}</span>
                </a>
              </Tooltip>
            </div> : null
          }
        </div>

        {
          state.documentDrawerVisible ?
            <UploadDocumentComponent
              visible={state.documentDrawerVisible}
              title={state.title}
              page={state.page}
              studentId={studentData._id}
              applicationId={applications._id}
              onClose={events.hideDrawer} /> : ''
        }
      </Card>
    </Drawer>
  )
}
export default DocumentDrawer
